var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { "background-color": "#ffffff" } },
    [
      _c(
        "el-col",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "flex-end",
            "align-items": "center",
            padding: "0 16px",
            gap: "10px"
          },
          attrs: { span: 24 }
        },
        [
          _c("span", { staticClass: "span-text" }, [_vm._v("Sort by:")]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: { placeholder: "Select" },
              on: { change: _vm.setSort },
              model: {
                value: _vm.selectedFilterOption,
                callback: function($$v) {
                  _vm.selectedFilterOption = $$v
                },
                expression: "selectedFilterOption"
              }
            },
            _vm._l(_vm.filterOptions, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticStyle: { padding: "0 16px 0 16px" }, attrs: { span: 24 } },
        [
          _c("el-row", {
            staticStyle: { "margin-top": "20px" },
            attrs: { gutter: 20 }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05cbf9a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05cbf9a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/searchResultsViewChange.vue
// module id = null
// module chunks = 